module.exports = __webpack_public_path__ + "img/723f246d4f184ec1ceaaac2ad32fd131.png";